import { connect } from 'react-redux';
import QuestionSetIndex from './QuestionSetIndex';
import * as examSelectors from 'edrolo/domains/exams/data/selectors';
import { fetchClassQuestionSetAggregates } from 'edrolo/domains/exams/data/actions';

const mapStateToProps = (state, { examId, classId, isTeacher }) => {
  return {
    classQuestionSetAggregates:
      isTeacher && classId
        ? examSelectors.getClassQuestionSetAggregates(state, examId, classId)
        : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchClassQuestionSetAggregates: (classId, examId) =>
    dispatch(fetchClassQuestionSetAggregates.signal(examId, classId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuestionSetIndex);
